import React from "react";
import { Route, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { compose } from "react-apollo";
import withCurrentUser from "../hocs/withCurrentUser";

const AuthRoute = ({
  component: Component,
  isAuthenticated,
  userData,
  ...rest
}) => (
  <Route
    {...rest}
    render={props => {
      const redirect = (
        <Redirect
          to={{ pathname: "/login", state: { from: props.location } }}
        />
      );

      if (!isAuthenticated) return redirect;
      if (userData.loading) return false;
      if (!userData.currentUser) return redirect;

      return <Component {...props} />;
    }}
  />
);

const mapStateToProps = state => ({
  isAuthenticated: state.auth.isAuthenticated
});

const enhance = compose(
  connect(mapStateToProps),
  withCurrentUser({
    skip: props => !props.isAuthenticated
  })
);

export default enhance(AuthRoute);



// WEBPACK FOOTER //
// ./src/components/AuthRoute.js